export const AI_FORM_STEPS = {
    FIRST: 1,
    SECOND: 2,
    LOADING: 3,
};